import { styled, Typography } from "@mui/material";

export const TooltipTitle = styled(Typography)(() => ({
  fontSize: "0.8rem",
  color: "#FFFFFF",
  backgroundColor: "#363636",
  padding: "0.3rem 0.5rem",
  borderRadius: "0.2rem",
}));
